export default __webpack_public_path__ + "static/media/Spring.82105aeb.jpg";